import axios from 'axios';
import AppConfig from "../../../AppConfig";

let URL = AppConfig.HOST_API() + 'raporty/'

export default {

    pobierzRaport(typ){
        return axios({
            method: 'get',
            url: URL+'raportKsiegowy?typ='+typ
        })
    },

}


// WEBPACK FOOTER //
// ./src/modules/raporty/Ksiegowosc/KsiegowoscService.js